import { typeIdObj } from '@/pages/home/utils/buriedPoint';
import type { pointInter as IBuriedPointCfg} from '@/pages/home/utils/buriedPoint';
export interface btnPointInter {
  buttonId: string,
  extInfo: string,
  pageId: string,
  typeId?: string
}
export const dbiTopChartsPageLogMes: {
  [key: string]: IBuriedPointCfg;
} = {
  'topChartsPcGames': {
    pageId: '305203',
    pageName: 'topChartsPcGames',
    pagePath: '/topCharts/pcGames',
    typeId: typeIdObj.intelligence,
  },
  'topChartsConsoleGames': {
    pageId: '305204',
    pageName: 'topChartsConsoleGames',
    pagePath: '/topCharts/consoleGames',
    typeId: typeIdObj.intelligence,
  },
  'topChartsPcConsoleGames': {
    pageId: '305205',
    pageName: 'topChartsPcConsoleGames',
    pagePath: '/topCharts/pcConsoleGames',
    typeId: typeIdObj.intelligence,
  },
  'topChartsPcGamesGamesDetails': {
    pageId: '305206',
    pageName: 'topChartsPcGamesGamesDetails',
    pagePath: '/topCharts/pcGames/gamesDetails',
    typeId: typeIdObj.intelligence,
  },
  'topChartsConsoleGamesDetails': {
    pageId: '305207',
    pageName: 'topChartsConsoleGamesDetails',
    pagePath: '/topCharts/consoleGames/gamesDetails',
    typeId: typeIdObj.intelligence,
  },
  'topChartsPcConsoleGamesDetails': {
    pageId: '305208',
    pageName: 'topChartsPcConsoleGamesDetails',
    pagePath: '/topCharts/pcConsoleGames/gamesDetails',
    typeId: typeIdObj.intelligence,
  },
}

export const soureInfo: {
  [key: string]: any;
}= {
  pc:{
    steam: 'Steam',
    Mscience: 'Mscience',
    gsd: 'GSD',
    npd: 'NPD',
    vginsights: 'VG Insights',
    newzoo: 'DataBrain',
  },
  console:{
    Mscience: 'Mscience',
    gsd: 'GSD',
    npd: 'NPD',
    newzoo: 'Engagement',
  },
  combine:{
    Mscience: 'Mscience',
    gsd: 'GSD',
    npd: 'NPD',
    vginsights: 'VG Insights',
    newzoo: 'DataBrain',
    famitsu: 'Japan Sales',
  },
}
export const dbiTopChartsBtnLogMes: {
  [key: string]: btnPointInter;
} = {
  // pcGames榜单
  // pcGames榜单-宽表segment
  pc_pcu_topChartsMetricsTableSegment: {
    pageId: '305203',
    buttonId: '305203001',
    extInfo: '/topCharts/pcGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  pc_digitalRevenue_topChartsMetricsTableSegment: {
    pageId: '305203',
    buttonId: '305203002',
    extInfo: '/topCharts/pcGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  pc_mau_topChartsMetricsTableSegment: {
    pageId: '305203',
    buttonId: '305203003',
    extInfo: '/topCharts/pcGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  pc_avg_daily_playtime_topChartsMetricsTableSegment: {
    pageId: '305203',
    buttonId: '305203004',
    extInfo: '/topCharts/pcGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  pc_churn_topChartsMetricsTableSegment: {
    pageId: '305203',
    buttonId: '305203005',
    extInfo: '/topCharts/pcGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  pc_time_spent_0H_topChartsMetricsTableSegment: {
    pageId: '305203',
    buttonId: '305203006',
    extInfo: '/topCharts/pcGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  pc_retention_d1_topChartsMetricsTableSegment: {
    pageId: '305203',
    buttonId: '305203007',
    extInfo: '/topCharts/pcGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  // Metric下拉选项
  pc_MetricsTable_topChartsMetricsSelector: {
    pageId: '305203',
    buttonId: '305203014',
    extInfo: '/topCharts/pcGames/MetricsTable页面-可视化图表Segment和Metrics下拉框选项',
    typeId: typeIdObj.intelligence,
  },
  // MoreFilter按钮
  pc_MetricsTable_MetricsMoreFilter: {
    pageId: '305203',
    buttonId: '305203015',
    extInfo: '/topCharts/pcGames/MetricsTable页面-头部筛选器的MoreFilter按钮',
    typeId: typeIdObj.intelligence,
  },
  // 下载按钮
  pc_MetricsTable_TopChartsMetricsTableDownload: {
    pageId: '301201',
    buttonId: '305203016',
    extInfo: '/topCharts/pcGames/MetricsTable页面-下载弹窗确认下载按钮',
    typeId: typeIdObj.intelligence,
  },
   // 点击下载按钮
   pc_MetricsTable_TopChartsMetricsTableDownloadBtn: {
    pageId: '305203',
    buttonId: '305203017',
    extInfo: '/topCharts/pcGames/MetricsTable页面-下载弹窗按钮',
    typeId: typeIdObj.intelligence,
  },
  // consoleGames榜单
  // consoleGames榜单-宽表segment

  console_digitalRevenue_topChartsMetricsTableSegment: {
    pageId: '305204',
    buttonId: '305204001',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  console_mau_topChartsMetricsTableSegment: {
    pageId: '305204',
    buttonId: '305204002',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  console_avg_daily_playtime_topChartsMetricsTableSegment: {
    pageId: '305204',
    buttonId: '305204003',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  console_churn_topChartsMetricsTableSegment: {
    pageId: '305204',
    buttonId: '305204004',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  console_time_spent_0H_topChartsMetricsTableSegment: {
    pageId: '305204',
    buttonId: '305204005',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  console_retention_d1_topChartsMetricsTableSegment: {
    pageId: '305204',
    buttonId: '305204006',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-宽表上的Sgement',
    typeId: typeIdObj.intelligence,
  },
  // Metric下拉选项
  console_MetricsTable_topChartsMetricsSelector: {
    pageId: '305204',
    buttonId: '305204011',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-可视化图表Metrics下拉框选项',
    typeId: typeIdObj.intelligence,
  },
  // MoreFilter按钮
  console_MetricsTable_MetricsMoreFilter: {
    pageId: '305204',
    buttonId: '305204012',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-头部筛选器的MoreFilter按钮',
    typeId: typeIdObj.intelligence,
  },
  // 下载按钮
  console_MetricsTable_TopChartsMetricsTableDownload: {
    pageId: '301301',
    buttonId: '305204013',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-下载弹窗确认下载按钮',
    typeId: typeIdObj.intelligence,
  },
   // 点击下载按钮
   console_MetricsTable_TopChartsMetricsTableDownloadBtn: {
    pageId: '305204',
    buttonId: '305204014',
    extInfo: '/topCharts/consoleGames/MetricsTable页面-下载弹窗按钮',
    typeId: typeIdObj.intelligence,
  },
  // PC & Console榜单页
  // Metric下拉选项
  combine_PCConsoleMetricsTable_topChartsMetricsSelector: {
    pageId: '305205',
    buttonId: '305205007',
    extInfo: '/topCharts/pcConsoleGames/MetricsTable页面-可视化图表Metrics下拉框选项',
    typeId: typeIdObj.intelligence,
  },
  combine_PCConsoleDataBrainCalibration_topChartsMetricsSelector: {
    pageId: '305205',
    buttonId: '305205007',
    extInfo: '/topCharts/pcConsoleGames/DataBrainCalibration页面-可视化图表Metrics下拉框选项',
    typeId: typeIdObj.intelligence,
  },
  // MoreFilter按钮
  combine_PCConsoleMetricsTable_MetricsMoreFilter: {
    pageId: '305205',
    buttonId: '305205008',
    extInfo: '/topCharts/pcConsoleGames/MetricsTable页面-头部筛选器的MoreFilter按钮',
    typeId: typeIdObj.intelligence,
  },
  combine_PCConsoleDataBrainCalibration_MetricsMoreFilter: {
    pageId: '305205',
    buttonId: '305205008',
    extInfo: '/topCharts/pcConsoleGames/DataBrainCalibration页面-头部筛选器的MoreFilter按钮',
    typeId: typeIdObj.intelligence,
  },
  // 下载按钮
  combine_PCConsoleMetricsTable_TopChartsMetricsTableDownload: {
    pageId: '303601',
    buttonId: '305205009',
    extInfo: '/topCharts/pcConsoleGames/MetricsTable页面-下载弹窗确认下载按钮',
    typeId: typeIdObj.intelligence,
  },
  combine_PCConsoleDataBrainCalibration_TopChartsMetricsTableDownload: {
    pageId: '303602',
    buttonId: '303602001',
    extInfo: '/topCharts/pcConsoleGames/DataBrainCalibration页面-下载弹窗确认下载按钮',
    typeId: typeIdObj.intelligence,
  },
  combine_PCConsoleAlineaAnalyticsCalibration_TopChartsDownload: {
    pageId: '303603',
    buttonId: '303603002',
    extInfo: '/topCharts/pcConsoleGames/AlineaAnalyticsCalibration页面-下载弹窗确认下载按钮',
    typeId: typeIdObj.intelligence,
  },
   // 点击下载按钮
  combine_PCConsoleMetricsTable_TopChartsMetricsTableDownloadBtn: {
    pageId: '305205',
    buttonId: '305205010',
    extInfo: '/topCharts/pcConsoleGames/MetricsTable页面-下载弹窗按钮',
    typeId: typeIdObj.intelligence,
  },
  combine_PCConsoleDataBrainCalibration_TopChartsMetricsTableDownloadBtn: {
    pageId: '305205',
    buttonId: '305205010',
    extInfo: '/topCharts/pcConsoleGames/DataBrainCalibration页面-下载弹窗按钮',
    typeId: typeIdObj.intelligence,
  },
  combine_PCConsoleAlineaAnalyticsCalibration_TopChartsDownloadBtn: {
    pageId: '303603',
    buttonId: '303603001',
    extInfo: '/topCharts/pcConsoleGames/AlineaAnalyticsCalibration页面-下载弹窗按钮',
    typeId: typeIdObj.intelligence,
  },
  combine_PCConsoleAlineaAnalyticsCalibration_TrueDataDrilldown: {
    pageId: '303603',
    buttonId: '303603003',
    extInfo: '/TopCharts/PCConsoleGames/AlineaAnalyticsCalibration真数下钻',
    typeId: typeIdObj.intelligence,
  },
  // 指标选择下拉框
  topChartsPcConsoleGamesMetricsSelector: {
    pageId: '305205',
    buttonId: '305205011',
    extInfo: '/topCharts/pcConsoleGames/MetricsTable页面-宽表上的Metrics选择器',
    typeId: typeIdObj.intelligence,
  },

  // PC详情
  // stats下载按钮
  pcpcuDownloadStatsExcel: {
    pageId: '301801',
    buttonId: '305206001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcdigitalRevenueDownloadStatsExcel: {
    pageId: '301806',
    buttonId: '305206002',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcgsdDownloadStatsExcel: {
    pageId: '301806',
    buttonId: '305206003',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcphysicalRevenueDownloadStatsExcel: {
    pageId: '301803',
    buttonId: '305206004',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcsteamSalesDownloadStatsExcel: {
    pageId: '301804',
    buttonId: '305206005',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcnewzooMetricsDownloadStatsExcel: {
    pageId: '301805',
    buttonId: '305206006',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  // PC详情stats segment
  pcpcuDetailSegment: {
    pageId: '305206',
    buttonId: '305206007',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcdigitalRevenueDetailSegment: {
    pageId: '305206',
    buttonId: '305206008',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcgsdDetailSegment: {
    pageId: '305206',
    buttonId: '305206009',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcphysicalRevenueDetailSegment: {
    pageId: '305206',
    buttonId: '305206010',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcsteamSalesDetailSegment: {
    pageId: '305206',
    buttonId: '305206011',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcnewzooMetricsDetailSegment: {
    pageId: '305206',
    buttonId: '305206012',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  // console详情
  // stats下载按钮
  consoledigitalRevenueDownloadStatsExcel: {
    pageId: '302101',
    buttonId: '305207001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consolegsdDownloadStatsExcel: {
    pageId: '302105',
    buttonId: '305207002',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consolephysicalRevenueDownloadStatsExcel: {
    pageId: '302102',
    buttonId: '305207003',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consolejapanSalesDownloadStatsExcel: {
    pageId: '302103',
    buttonId: '305207004',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consolenewzooMetricsDownloadStatsExcel: {
    pageId: '302104',
    buttonId: '305207005',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  // Console详情stats segment
  consoledigitalRevenueDetailSegment: {
    pageId: '305207',
    buttonId: '305207006',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consolegsdDetailSegment: {
    pageId: '305207',
    buttonId: '305207007',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consolephysicalRevenueDetailSegment: {
    pageId: '305207',
    buttonId: '305207008',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consolejapanSalesDetailSegment: {
    pageId: '305207',
    buttonId: '305207009',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consolenewzooMetricsDetailSegment: {
    pageId: '305207',
    buttonId: '305207010',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  // combine详情页
  // stats下载按钮
  combinepcuDownloadStatsExcel: {
    pageId: '305208',
    buttonId: '305208001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinedigitalRevenueDownloadStatsExcel: {
    pageId: '303901',
    buttonId: '305208002',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinegsdDownloadStatsExcel: {
    pageId: '305208',
    buttonId: '305208003',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinephysicalRevenueDownloadStatsExcel: {
    pageId: '303902',
    buttonId: '305208004',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinesteamSalesDownloadStatsExcel: {
    pageId: '303903',
    buttonId: '305208005',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinenewzooMetricsDownloadStatsExcel: {
    pageId: '303905',
    buttonId: '305208006',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinejapanSalesDownloadStatsExcel: {
    pageId: '303904',
    buttonId: '305208007',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combineallMetricsDownloadStatsExcel: {
    pageId: '303906',
    buttonId: '305208008',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  // combine详情stats segment
  combineallMetricsDetailSegment: {
    pageId: '305208',
    buttonId: '305208009',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinedigitalRevenueDetailSegment: {
    pageId: '305208',
    buttonId: '305208010',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinegsdDetailSegment: {
    pageId: '305208',
    buttonId: '305208011',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinesteamSalesDetailSegment: {
    pageId: '305208',
    buttonId: '305208012',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinephysicalRevenueDetailSegment: {
    pageId: '305208',
    buttonId: '305208013',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinejapanSalesDetailSegment: {
    pageId: '305208',
    buttonId: '305208014',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  combinenewzooMetricsDetailSegment: {
    pageId: '305208',
    buttonId: '305208015',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pdigitalRevenue_renderDigitalSegment:{
    pageId: '305205',
    buttonId: '305205021',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  pcdigitalRevenue_rangeTime:{
    pageId: '305205',
    buttonId: '305205020',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  }
};
